import React from "react";
import styled from "react-emotion";
import { inject, observer } from "mobx-react";
import { progress } from "../../utilities";

const Wrap = styled.div``;

const PicAbs = styled.img`
  width: ${props => "${props.width}px" || "100%"};
  height: ${props => "${props.height}px" || "auto"};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: ${props => (props.index === props.z ? "block" : "none")};
`;

class ImageStack extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      getProgress: progress(this.props.steps, this.props.images.length)
    };
  }
  render() {
    const z = this.state.getProgress(this.props.measure);
    return (
      <React.Fragment>
        {this.props.images.map((s, x) => (
          <PicAbs
            key={x}
            index={x}
            z={z}
            src={s}
            height={this.props.height}
            width={this.props.width}
          />
        ))}
      </React.Fragment>
    );
  }
}

ImageStack.defaultProps = {
  spread: 10
};

export const ScrollStack = inject(({ store }) => ({
  measure: store.uiStore.scroll.scrolling
}))(observer(ImageStack));

export const TimerStack = inject(({ store }) => ({
  measure: store.appStore.ticks.time
}))(observer(ImageStack));



// WEBPACK FOOTER //
// ./src/components/ImageStack/index.js